import AddIcon from '@mui/icons-material/Add';
import { Grid, styled, TextField, Typography } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-redux-multilingual';
import * as Yup from 'yup';
import { LetsGoBtn } from '../../components/Buttons';
import Page from '../../components/Page';
import { StyledTitle } from '../../components/StyledComponents';
import { emailRegExp } from '../../services/regularExp';
import '../MainPage/index.css';
import ApiService from '../../helpers/apiHelper';
import { setIsOpenSupportModal } from '../../redux/mainReducer';
import { useDispatch } from 'react-redux';
import { Spinner } from '../../components/Spinner';
import CloseIcon from '@mui/icons-material/Close';
import { ImageOutlined } from '@mui/icons-material';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

function SupportPage() {
  // const apiSendMessage = new ApiService('send-message');
  // const apiSendPhotoMessage = new ApiService('send-photo-message');
  const apiSendMessage = new ApiService('mail/send-message');
  const apiSendPhotoMessage = new ApiService('mail/send-photo-message');
  const apiSendToSupport = new ApiService('auth/create-support');

  const [imgs, setImgs] = useState([]);
  const [imgsToDelete, setImgsToDelete] = useState([]);
  const [randomPlaceholder, setRandomPlaceholder] = useState(0);
  const [randomDesc, setRandomDesc] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const translate = useTranslate();
  const dispatch = useDispatch();
  const placeholders = [
    'Не стримуйтесь, розкажіть про свою халепу.*',
    'Опишіть свою халепу тут, бажано обсягом до 1000 символів.*'
  ];
  const descriptions = [
    'Підтримаємо, яка б біда з платформою вас не спіткала. Просимо, розкажіть про халепу.',
    'Одна голова добре, дві ліпше, але хай одна розважить і поважить. В чому халепа?',
    'Одна голова добре, дві ліпше. Розкажіть, в чому халепа?',
    'Разом, кажуть люди, навіть легше плакати. Тому давайте розбиратись. '
  ];

  const schema = Yup.object().shape(
    {
      name: Yup.string().required(translate('error_required')).max(100, 'Максимально 100 символів'),
      contact: Yup.string()
        .matches(emailRegExp, translate('error_regExp_email'))
        .required(translate('error_required')),
      subject: Yup.string()
        .required(translate('error_required'))
        .max(150, 'Максимально 150 символів'),
      text: Yup.string()
        .min(1, 'Мінімально 1 символ')
        .max(1000, 'Максимально 1000 символів')
        .required('Мінімально 1 символ')
    },
    [['text', 'text']]
  );

  const formik = useFormik({
    initialValues: {
      name: '',
      contact: '',
      subject: '',
      text: ''
    },
    enableReinitialize: true,
    validationSchema: schema,

    onSubmit: (values, { resetForm, setErrors }) => {
      setIsLoading(true);
      if (values) {
        if (imgs.length === 0) {
          apiSendMessage
            .sendRequest({
              name: values.name,
              subject: values.subject,
              contact: values.contact,
              text: values.text,
              type: 'DataMessage'
            })
            .then((res) => {
              apiSendToSupport
                .sendRequest({
                  name: values.name,
                  subject: values.subject,
                  email: values.contact,
                  text: values.text
                })
                .then((result) => {
                  setIsLoading(false);
                  dispatch(setIsOpenSupportModal(true));
                  resetForm();
                })
                .catch((error) => {
                  console.error(error);
                  setIsLoading(false);
                });
            })
            .catch((error) => {
              console.error(error);
              setIsLoading(false);
            });
        } else {
          apiSendPhotoMessage
            .sendRequest(
              {
                name: values.name,
                subject: values.subject,
                contact: values.contact,
                text: values.text,
                photos: imgs,
                type: 'DataMessageWithPhoto'
              },
              true
            )
            .then((res) => {
              apiSendToSupport
                .sendRequest({
                  name: values.name,
                  subject: values.subject,
                  email: values.contact,
                  text: values.text
                })
                .then((result) => {
                  setIsLoading(false);
                  dispatch(setIsOpenSupportModal(true));
                  resetForm();
                })
                .catch((error) => {
                  console.error(error);
                  setIsLoading(false);
                });
            })
            .catch((error) => {
              console.error(error);
              setIsLoading(false);
            });
        }
      }
    }
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    submitForm,
    // eslint-disable-next-line
    resetForm,
    // eslint-disable-next-line
    setErrors
    // setFieldValue
  } = formik;
  useEffect(() => {
    setRandomPlaceholder(Math.floor(Math.random() * placeholders.length));
    setRandomDesc(Math.floor(Math.random() * descriptions.length));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const fileInput = document.getElementById('button-file-post');
    if (fileInput) {
      fileInput.addEventListener('change', (event) => {
        if (imgs.length !== 10) {
          const newArray = [...imgs];
          newArray.push(event.target.files[0]);
          setImgs([...newArray]);
        }
      });
    }
  });

  return (
    <Page
      title="Підтримка"
      description="Сторінка підтримки сайту BONFAIR"
      isIndex={true}
      canonical={window.location.origin + window.location.pathname}
      style={{
        display: 'flex',
        marginTop: '150px',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        height: 'max-content',
        padding: { xs: '0px 20px', sm: '0px 20px', md: '0px 50px', lg: '0px 100px' }
      }}
    >
      {/* <div
        style={{
          height: 'calc(94vh - 230px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      > */}
      <StyledTitle
        variant="h1"
        maxWidth={800}
        sx={{
          lineHeight: '38px !important',
          fontSize: '32px !important',
          textTransform: 'initial !important',
          margin: '0px auto !important'
        }}
        className="bottomBlock-title"
      >
        Підтримка
      </StyledTitle>
      <Typography
        sx={{
          fontStyle: 'normal',
          fontWeight: '400',
          fontSize: { xs: '16px', sm: '20px' },
          lineHeight: '29px',
          textAlign: 'center',
          margin: '30px 0px 40px 0px',
          maxWidth: '500px',
          fontFamily: 'FixelText-Regular !important'
        }}
      >
        {descriptions[randomDesc]}
      </Typography>
      <FormikProvider value={formik}>
        <Form
          autoComplete="off"
          noValidate
          onSubmit={handleSubmit}
          style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}
        ></Form>
        <Grid container spacing={2} sx={{ maxWidth: '816px', mb: 5 }}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ fontSize: 24, fontFamily: 'FixelText-SemiBold' }}>
              Контактна інформація
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column' }}>
            <CssTextField
              placeholder="Ім'я*"
              variant="outlined"
              fullWidth
              size="normal"
              inputProps={{ style: { textAlign: 'left' } }}
              error={Boolean(touched.name && errors.name)}
              {...getFieldProps('name')}
              value={values.name}
            >
              {values.name}
            </CssTextField>
            {touched.name && errors.name && (
              <div
                style={{
                  color: 'red',
                  margin: '5px 0px',
                  fontSize: '14px',
                  fontFamily: 'FixelText-Regular'
                }}
              >
                {errors.name}
              </div>
            )}
          </Grid>
          <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column' }}>
            <CssTextField
              placeholder="E-mail*"
              variant="outlined"
              fullWidth
              size="normal"
              inputProps={{ style: { textAlign: 'left' } }}
              error={Boolean(touched.contact && errors.contact)}
              {...getFieldProps('contact')}
              value={values.contact}
            >
              {values.contact}
            </CssTextField>
            {touched.contact && errors.contact && (
              <div
                style={{
                  color: 'red',
                  margin: '5px 0px',
                  fontSize: '14px',
                  fontFamily: 'FixelText-Regular'
                }}
              >
                {errors.contact}
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ fontSize: 24, fontFamily: 'FixelText-SemiBold' }}>
              Ваше повідомлення
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
            <CssTextField
              placeholder="Тема звернення*"
              variant="outlined"
              fullWidth
              size="normal"
              inputProps={{ style: { textAlign: 'left' } }}
              error={Boolean(touched.subject && errors.subject)}
              {...getFieldProps('subject')}
              value={values.subject}
            >
              {values.subject}
            </CssTextField>
            {touched.subject && errors.subject && (
              <div
                style={{
                  color: 'red',
                  margin: '5px 0px',
                  fontSize: '14px',
                  fontFamily: 'FixelText-Regular'
                }}
              >
                {errors.subject}
              </div>
            )}
          </Grid>
          <Grid item xs={12}>
            <CssTextField
              placeholder={placeholders[randomPlaceholder]}
              multiline
              rows={8}
              fullWidth
              inputProps={{ style: { textAlign: 'left' } }}
              error={Boolean(touched.text && errors.text)}
              {...getFieldProps('text')}
              value={values.text}
            >
              {values.text}
            </CssTextField>
            {values.text.length !== 0 && (
              <p
                style={{
                  margin: '0 5px',
                  color: 'gray',
                  textAlign: 'right',
                  fontSize: '14px'
                }}
              >{`${values.text.length}/1000`}</p>
            )}

            {touched.text && errors.text && (
              <div
                style={{
                  color: 'red',
                  margin: '5px 0px',
                  fontSize: '14px',
                  fontFamily: 'FixelText-Regular'
                }}
              >
                {errors.text}
              </div>
            )}
          </Grid>

          <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle" sx={{ fontSize: 24, fontFamily: 'FixelText-SemiBold' }}>
              Ви можете прикріпити зображення, які ілюструють суть проблеми.
            </Typography>
            <Typography
              variant="subtitle"
              sx={{
                fontSize: 20,
                color: '#7c7c7c',
                width: '100%',
                fontFamily: 'FixelText-Regular'
              }}
            >
              Можливо завантажити до 10 вкладень. Один елемент не має важити більше 10 МБ.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'flex-start',
                gap: '12px',
                alignSelf: 'stretch',
                zIndex: '99',
                // paddingTop: '14px',
                padding: '12px',
                marginBottom: '20px',
                marginLeft: 'auto',
                marginRight: 'auto',
                boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                background: 'white',
                borderRadius: '5px'
              }}
            >
              {imgs.length !== 0 &&
                imgs.map((file, index) => (
                  <div
                    key={'image' + index}
                    className="uploaded-img-modal"
                    // style={
                    //   index === 0 || index === imgs.length - 1
                    //     ? { marginLeft: '10px', marginTop: '14px' }
                    //     : { marginLeft: '14px', marginTop: '14px' }
                    // }
                    // style={{ margin: 'auto' }}
                  >
                    {/*{index === 0 ? (*/}
                    {/*  <div*/}
                    {/*    style={{*/}
                    {/*      position: 'absolute',*/}
                    {/*      backgroundColor: '#E2F2FF',*/}
                    {/*      padding: '4px 8px',*/}
                    {/*      borderRadius: '4px',*/}
                    {/*      boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',*/}
                    {/*      fontFamily: 'FixelText-Medium',*/}
                    {/*      fontWeight: '500',*/}
                    {/*      color: '#60A5DF',*/}
                    {/*      fontSize: '14px',*/}
                    {/*      top: '4px',*/}
                    {/*      left: '4px'*/}
                    {/*    }}*/}
                    {/*  >*/}
                    {/*    Обкладинка*/}
                    {/*  </div>*/}
                    {/*) : null}*/}
                    <img
                      style={{ objectFit: 'cover' }}
                      alt={'img' + index}
                      width={60}
                      src={URL.createObjectURL(file)}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        backgroundColor: 'white',
                        width: '26px',
                        height: '26px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '50px',
                        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                        cursor: 'pointer',
                        top: '4px',
                        right: '4px'
                      }}
                      onClick={() => {
                        const newArray = imgs;
                        const newImgsToDelete = imgsToDelete;

                        newArray.splice(index, 1);
                        setImgs([...newArray]);
                        setImgsToDelete([...newImgsToDelete]);
                      }}
                    >
                      <CloseIcon sx={{ fontSize: '20px' }} />
                    </div>
                  </div>
                ))}
              <input
                multiple
                accept=".jpeg,.jpg,.png"
                // style={{ display: 'none' }}
                style={{ position: 'absolute', opacity: 0, zIndex: 99, display: 'none' }}
                id="button-file-post"
                disabled={imgs.length === 10}
                type="file"
              />
              {imgs.length !== 10 && (
                <label htmlFor="button-file-post">
                  <div className="uploaded-img-modal-label">
                    <ImageOutlined
                      style={{ color: 'black' }}
                      sx={{
                        mt: 1,
                        fontSize: 35,
                        '&:hover': {
                          width: 100
                        }
                      }}
                    />
                    <Typography
                      sx={{
                        mt: 2,
                        display: 'flex',
                        alignItems: 'center',
                        fontFamily: 'FixelText-Medium'
                      }}
                    >
                      <AddIcon sx={{ color: 'black', mr: '2px' }} /> Додати
                    </Typography>
                  </div>
                </label>
              )}
            </div>
          </Grid>
        </Grid>{' '}
        {!isLoading ? (
          <LetsGoBtn
            colorScheme="blue"
            disabled={
              values.name.length === 0 ||
              errors.name ||
              values.contact.length === 0 ||
              errors.contact ||
              values.subject.length === 0 ||
              errors.subject ||
              values.text.length === 0 ||
              errors.text
            }
            width={257}
            onClick={() => {
              submitForm();
            }}
            text="Відправити"
          />
        ) : (
          <div style={{ marginTop: '10px' }}>
            <Spinner type="small" />
          </div>
        )}
        <Typography variant="subtitle" sx={{ fontSize: 16, maxWidth: '810px', marginTop: '50px' }}>
          Якщо вам не вдається відправити форму або виникли інші труднощі, ви можете надіслати емейл
          на нашу пошту{' '}
          <a style={{ fontSize: 16, color: 'black' }} href="mailto:info@bandbsolution.com.ua">
            info@bandbsolution.com.ua.
          </a>
        </Typography>
      </FormikProvider>

      {/* </div> */}
    </Page>
  );
}

export default SupportPage;
